import { Box, Link, Stack, Typography } from '@mui/material';

export const Footer = () => (
  <Box
    height="54px"
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: { xs: 'center', sm: 'space-between' },
      alignItems: 'center',
      fontSize: '0.875rem',
      color: '#444',
      gap: { xs: 1, sm: 0 },
      textAlign: { xs: 'center', sm: 'left' },
    }}
    py={{ xs: '1rem', sm: '1rem 2rem' }}
    px={{ xs: '16px', sm: '32px 16px', md: '80px' }}
  >
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
      <Link
        href="https://www.hyde-housing.co.uk/privacy/hyde-foundation-privacy/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
      >
        Privacy Policy
      </Link>
      <Link
        href="https://www.hyde-housing.co.uk/privacy/hyde-foundation-privacy/hyde-foundation-digital-tools-terms-of-use/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
      >
        Terms of Use
      </Link>
      {/* <Link href="#" underline="hover" color="inherit">
        Cookie Policy
      </Link> */}
      {/* <Link href="#" underline="hover" color="inherit">
        Accessibility Statement
      </Link> */}
      {/* <Link href="#" underline="hover" color="inherit">
        Support
      </Link> */}
    </Stack>
    <Typography variant="body2" sx={{ mt: { xs: 1, sm: 0 } }}>
      The Hyde Group {new Date(Date.now()).getFullYear()}
    </Typography>
  </Box>
);
